import React, {useState } from 'react'
import SiteLayout from '../../component/layout/Layout'
import './createGame.css'
import paymentimg from '../../assets/img/payment.svg'
import p1Logo from '../../assets/img/Playarone-logo-dark.svg'
import trophy from '../../assets/img/trophy.svg'
import { Row, Col, Button, Input, Select } from 'antd';


const CreateGame = () => {
    const { Option } = Select;
    const { TextArea } = Input;

    const [createGame, setCreateGame] = useState(true)
    const [payment, setpayment] = useState(false)

    const advance = () => {
        setCreateGame(false)
        setpayment(true)
    }

    return(
        <SiteLayout>
            <Row className="create_game_container">
                <Col className={`gutter-row create_game_three ${createGame === true ? 'show' : 'hide'}`} xs = {{ span: 24 }} sm = {{ span: 24 }} md = {{ span: 24 }} lg = {{ span: 24 }} xl ={{ span: 24 }}>

                    <Row gutter={[16, 24]} className="create_game3_container">

                        <Col xs = {{ span: 24 }} sm = {{ span: 22 }} md = {{ span: 18 }} lg = {{ span: 14 }} xl ={{ span: 12 }}>

                            <div className="create_gamethree_holder">
                                <img src={p1Logo} alt="" style={{ width: '60px' }}/>

                                <p className="create_game_text">Create Game (1 of 2)</p>

                                <div className="signup_plan">
                                    <Row gutter={[16, 24]}>
                                        <Col xs = {{ span: 24 }} sm = {{ span: 12 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl ={{ span: 12 }}>
                                            <Select defaultValue="Select Game type">
                                                <Option value="Option1-1">Favourite Streaming Channel</Option>
                                                <Option value="Option1-2">Favourite Streaming Channel-2</Option>
                                            </Select>
                                        </Col>
                                        <Col xs = {{ span: 24 }} sm = {{ span: 12 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl ={{ span: 12 }}>
                                            <Select defaultValue="Select Game">
                                                <Option value="Option1-1">Favourite Streaming Channel</Option>
                                                <Option value="Option1-2">Favourite Streaming Channel-2</Option>
                                            </Select>
                                        </Col>
                                        <Col xs = {{ span: 24 }} sm = {{ span: 12 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl ={{ span: 12 }}>
                                            <Select defaultValue="Select Game mode">
                                                <Option value="Option1-1">Favourite Streaming Channel</Option>
                                                <Option value="Option1-2">Favourite Streaming Channel-2</Option>
                                            </Select>
                                        </Col>
                                        <Col xs = {{ span: 24 }} sm = {{ span: 12 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl ={{ span: 12 }}>
                                            <Select defaultValue="Select console">
                                                <Option value="Option1-1">Favourite Streaming Channel</Option>
                                                <Option value="Option1-2">Favourite Streaming Channel-2</Option>
                                            </Select>
                                        </Col>
                                        <Col xs = {{ span: 24 }} sm = {{ span: 12 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl ={{ span: 12 }}>
                                            <Input placeholder="₦ Entry / Stake fee" />
                                        </Col>
                                        <Col xs = {{ span: 24 }} sm = {{ span: 12 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl ={{ span: 12 }}>
                                            <Select defaultValue="Match type">
                                                <Option value="Option1-1">Favourite Streaming Channel</Option>
                                                <Option value="Option1-2">Favourite Streaming Channel-2</Option>
                                            </Select>
                                        </Col>
                                        <Col xs = {{ span: 24 }} sm = {{ span: 12 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl ={{ span: 12 }}>
                                            <Input.Group size="large">
                                                <Row gutter={8}>
                                                    <Col span={12}>
                                                    <Input placeholder="Date" />
                                                    </Col>
                                                    <Col span={12}>
                                                    <Input placeholder="Time" />
                                                    </Col>
                                                </Row>
                                            </Input.Group>
                                        </Col>
                                        <Col xs = {{ span: 24 }} sm = {{ span: 12 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl ={{ span: 12 }}>
                                            <Input placeholder="Numbers of players to join" />
                                        </Col>
                                        <Col xs = {{ span: 24 }} sm = {{ span: 24 }} md = {{ span: 24 }} lg = {{ span: 24 }} xl ={{ span: 24 }}>
                                            <TextArea rows={8} />
                                        </Col>
                                    </Row>
                                </div>

                                <Button type="primary" onClick={advance}>CONTINUE</Button>

                            </div>

                        </Col>

                    </Row>

                </Col>
            
                <Col className={`gutter-row create_game_three ${payment === true ? 'show' : 'hide'}`} xs = {{ span: 24 }} sm = {{ span: 24 }} md = {{ span: 24 }} lg = {{ span: 24 }} xl ={{ span: 24 }}>
                    <Row gutter={[16, 24]} className="create_game3_container">
                        <Col xs = {{ span: 24 }} sm = {{ span: 22 }} md = {{ span: 18 }} lg = {{ span: 14 }} xl ={{ span: 8 }}>
                            <div className="create_gamethree_holder">
                                <img src={paymentimg} alt="" style={{ width: '60px' }}/>
                                <p className="create_game_text">Create Game (2 of 2)</p>

                                <div className="create_game_final game_type">
                                    <h4>GAME TYPE: MATCH</h4>
                                    <div className="game_editing">
                                        <div>
                                            <p>Fifa 20: Standard Edition</p>
                                            <p>Entry/Stake Fee: ₦ 3,470 </p>
                                        </div>
                                        <p>Edit Listing</p>
                                    </div>
                                </div>
                                <div className="create_game_final game_details_holder">
                                    <div className="game_details">
                                        <h4>MATCH TYPE: PUBLIC</h4>
                                        <h4>CONSOLE: PS4</h4>
                                        <h4>MODE: 1 vs 1</h4>
                                        <h4>PLAYERS: 1</h4>
                                        <h4>DATE: SEP. 2</h4>
                                        <h4>TIME: 06:00 PM</h4>
                                    </div>
                                    <div className="game_winner_prize">
                                        <img src={trophy} alt=""/>
                                        <div className="prize">
                                            <p>₦ 6,070 (90%)</p>
                                            <h3>Winner<br />
                                                Prize</h3>
                                        </div>
                                    </div>
                                </div>
                                <Button type="primary" className="payment">Proceed to Payment</Button>
                            </div>
                        </Col>
                    </Row>
                    
                </Col>
            
            </Row>
        </SiteLayout>
    );
}

export default CreateGame;